export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["ACTIVE"] = "ACTIVE";
    NotificationStatus["VIEWED"] = "VIEWED";
    NotificationStatus["ARCHIVED"] = "ARCHIVED";
    NotificationStatus["DISMISSED"] = "DISMISSED";
    NotificationStatus["DELETED"] = "DELETED";
})(NotificationStatus || (NotificationStatus = {}));
export var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel["INFO"] = "INFO";
    SeverityLevel["ERROR"] = "ERROR";
    SeverityLevel["WARNING"] = "WARNING";
    SeverityLevel["SUCCESS"] = "SUCCESS";
})(SeverityLevel || (SeverityLevel = {}));
